import { Button, Divider, IconButton, Link, Stack, Tooltip, Typography } from '@mui/material';
import React from 'react';
import { CloseIcon } from './Icons/Icons';
import { AppColors } from '../Utils/helper/AppColors';

export default function FilterSelectionContainer({
	onClose,
	children,
	handleApplyChanges,
	handleResetCheck,
	resetDisable,            // its disable when no filter is selected
	title = 'dashboard',
	width
}) {

	return (
		<Stack height="100%" width='100%' p={2}  gap={2} sx={{backgroundColor : AppColors.NEW_BACKGROUND}}>
			<Stack direction="row" alignItems="center" justifyContent="flex-end" gap={2}>
				{/* <Stack alignItems="flex-start" gap={0.5}>
					<Typography variant="body1">Filters</Typography>
					<Typography variant="subtitle2">Apply filters to {title}</Typography>
				</Stack> */}

				<Stack direction="row" alignItems="center" spacing={2}>
					{/* <Link
						disabled={!resetDisable}
						component="button"
						variant="body1"
						underline="none"
						onClick={handleResetCheck}
						sx={{
							color: resetDisable ? 'primary.main' : 'text.disabled',
							cursor: resetDisable ? 'pointer' : 'not-allowed',
						}}
					>
						Reset
					</Link> */}

					<IconButton onClick={onClose} size="small">
						<CloseIcon />
					</IconButton>
				</Stack>
			</Stack>

			{/* <Divider /> */}

			{/* Scrollable Children Section */}
			<Stack sx={{ flexGrow: 1, overflowY: 'auto' }}>{children}</Stack>

			<Divider sx={{ mt: 'auto' }} />
			<Stack direction="row" alignItems="center" gap={2} justifyContent="center">
				<Button onClick={onClose} variant="outlined" color='info' >
					Cancel
				</Button>
				{/* tooltip not working  */}
				<Tooltip title="Apply selected filters" placement='right'>                          
				<Button disabled={!resetDisable} onClick={handleApplyChanges} variant="contained" color='info' >
					Apply
				</Button>
				</Tooltip>
			</Stack>
		</Stack>
	);
}
